<app-leveltwo [videos]="true" [pageName]="'Death of Real Property Owner'">
    <div heading="General Info" class="General">
      <h3>{{'DeathofaPropertyOwner.SearchTitle'|translate}}</h3>
      <p [innerHTML]="'DeathofaPropertyOwner.TheAssesor'|translate"></p>
      <p [innerHTML]="'DeathofaPropertyOwner.Note'|translate"></p>
      <h4>{{'DeathofaPropertyOwner.FilingRequirements'|translate}}</h4>
      <p>{{'DeathofaPropertyOwner.Failure'|translate}}</p>
      <p [innerHTML]="'DeathofaPropertyOwner.Click'|translate"></p>
      <h4>{{'DeathofaPropertyOwner.Checklist'|translate}}</h4>
      <p><b>{{'DeathofaPropertyOwner.IfDecedenthad'|translate}}</b></p>
      <ul>
        <li [innerHTML]="'DeathofaPropertyOwner.Changein'|translate"></li>
        <li>{{'DeathofaPropertyOwner.DeathCert'|translate}}</li>
        <li>{{'DeathofaPropertyOwner.Copyof'|translate}}</li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforParent'|translate"></li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforGrandparent'|translate"></li>
        <li>{{'DeathofaPropertyOwner.CopyofState'|translate}}</li>
      </ul>

      <p><b>{{'DeathofaPropertyOwner.IfDecedentdidnot'|translate}}</b></p>
      <ul>
        <li [innerHTML]="'DeathofaPropertyOwner.Changein'|translate"></li>
        <li>{{'DeathofaPropertyOwner.DeathCert'|translate}}</li>
        <li>{{'DeathofaPropertyOwner.Lettersof'|translate}}</li>
        <li>{{'DeathofaPropertyOwner.Listof'|translate}}</li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforParent'|translate"></li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforGrandparent'|translate"></li>
        <li>{{'DeathofaPropertyOwner.CopyofState'|translate}}</li>
      </ul>

      <p><b>{{'DeathofaPropertyOwner.IfDecedentTrust'|translate}}</b></p>
      <ul>
        <li [innerHTML]="'DeathofaPropertyOwner.Changein'|translate"></li>
        <li>{{'DeathofaPropertyOwner.DeathCert'|translate}}</li>
        <li>{{'DeathofaPropertyOwner.EntireTrust'|translate}}</li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforParent'|translate"></li>
        <li [innerHTML]="'DeathofaPropertyOwner.ClaimforGrandparent'|translate"></li>
        <li>{{'DeathofaPropertyOwner.CopyofState'|translate}}</li>
      </ul>




    </div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
